import { useUserConfig } from '@littlebird/sdk';

/** The user's minimum card importance from their config; 0 means every card shows. */
export const useMinCardImportance = () => {
  // React Compiler would cache the settings store read and miss its changes.
  'use no memo';

  const userConfig = useUserConfig();
  return {
    minImportance: userConfig.proactiveAgents.get('min_card_importance'),
    setMinImportance: (value: number) =>
      userConfig.proactiveAgents.set('min_card_importance', value),
  };
};
